module.exports = __webpack_public_path__ + "static/media/1012852.b9132b8a.png";